<template>
  <div style="background-color: black">
    <div class="fc-event" :style="`${eventStyle}`">
      <el-popover
        class=""
        placement="top-start"
        title="Đặt phòng"
        width="300"
        :hide-after="0"
        style="height: 100%"
        :trigger="isAgent ? 'manual' : 'click'"
      >
        <template v-if="!isAgent && event.type != 3" #reference>
          <div style="width: 100%; height: 100%">
            <div class="fc-event-icon fc-event-label">
              <div>
                {{
                  `${event.source == 'WEB_HOTEL' && event.type == 7 ? 'Khách tạm giữ phòng Website' : event.name}`
                }}
              </div>
            </div>
          </div>
        </template>
        <div>
          <div>
            <div v-if="event.source">Nguồn: {{ `${event.source}` }}</div>
            <div v-if="event.group_name">Đoàn: {{ `${event.group_name}` }}</div>
            <div>
              Khách hàng:
              {{
                `${event.source == 'WEB_HOTEL' && event.type == 7 ? 'Khách tạm giữ phòng Website' : event.name}`
              }}
            </div>
          </div>
          <div style="text-align: right; margin: 0">
            <el-button
              v-show="event?.booking_code"
              type="text"
              class=""
              @click="onViewBooking"
            >
              Xem nhóm
            </el-button>
            <el-button
              v-show="event?.booking_id"
              type="text"
              class=""
              @click="onViewBookingRoom"
            >
              Xem phòng đặt
            </el-button>
            <el-button
              v-show="event?.booking_group_id"
              type="text"
              class=""
              @click="onViewBookingGroup"
            >
              Xem Đoàn
            </el-button>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import { parseDateTimeToLocal } from '@/utils/date'
export default {
  props: {
    event: {
      required: true
    },
    userGroups: {
      required: true
    },
    startDateObject: {
      required: true
    },
    dayCellWith: {
      required: true
    },
    displayHour: {
      required: true,
      default: true
    }
  },
  data() {
    return {
      infoVisible: false,
      types: [
        { color: '30, 132, 73', value: 1, label: 'Đã đặt phòng' },
        { color: '36, 113, 163', value: 2, label: 'Đang ở' },
        { color: '39, 55, 70 ', value: 3, label: 'Phòng không sử dụng' },
        { color: '195, 40, 23', value: 4, label: 'Đã hủy' },
        { color: '125, 60, 152', value: 5, label: 'Đã trả phòng' },
        { color: '244, 208, 63 ', value: 6, label: 'Ở trong ngày' },
        { color: '146, 43, 33', value: 7, label: 'Đặt phòng tạm giữ' }
      ]
    }
  },
  computed: {
    eventStyle() {
      if (parseInt(this.event.type) === 4) {
        return 'display: none;'
      }
      const dayOffset = 24 * 60 * 60 * 1000
      const startTime = this.startDateObject.getTime()

      const fromDateObject = parseDateTimeToLocal(this.event.date_from)
      if (!this.displayHour) {
        fromDateObject.setHours(0)
        fromDateObject.setMinutes(0)
        fromDateObject.setSeconds(0)
      }
      const fromTime = fromDateObject.getTime()

      const startDateObject = new Date(this.event.date_to)
      if (!this.displayHour) {
        startDateObject.setHours(0)
        startDateObject.setMinutes(0)
        startDateObject.setSeconds(0)
      }
      let toTime = startDateObject.getTime()

      if (toTime === fromTime) {
        toTime += dayOffset
      }

      const startPos = Math.floor(
        ((fromTime - startTime) / (60 * 60 * 24 * 1000)) * this.dayCellWith
      )
      const width = Math.floor(
        ((toTime - fromTime) / (60 * 60 * 24 * 1000)) * this.dayCellWith
      )
      // Check FullCalendar component for css variable --bookable-cell-display
      const displayStyle = this.isCellBookable()
        ? 'display: var(--bookable-cell-display);'
        : 'display: block;'
      const style = `
      left: ${startPos + 1}px;
      width: ${Math.max(0, width - 2)}px;
      z-index: ${Math.max(startPos + 1, 1)};
      ${displayStyle}
      --fc-event-color: ${this.types[this.event.type - 1].color};`
      return style
    },
    isAgent() {
      return (
        this.userGroups.length === 1 &&
        this.userGroups[0].toLowerCase() === 'agent'
      )
    }
  },
  methods: {
    isCellBookable() {
      // Exclude "đã hủy" and "đã trả phòng"
      return [4, 5].includes(parseInt(this.event.type))
    },
    onViewBooking() {
      const routeData = this.$router.resolve({
        path: '/reservation/new_reservation',
        query: {
          action: 'edit',
          id: this.event?.booking_code
        }
      })
      window.open(routeData.href, '_blank')
    },
    onViewBookingRoom() {
      if (!this.isAgent) {
        this.$emit('viewBooking', this.event.booking_id)
        // const routeData = this.$router.resolve({
        //   path: '/reservation/new_reservation',
        //   query: {
        //     action: 'view',
        //     id: this.event?.booking_id
        //   }
        // })
        // window.open(routeData.href, '_blank')
      }
    },
    onViewBookingGroup() {
      // this.$emit('viewBookingGroup', this.event.booking_group_id)
      const routeData = this.$router.resolve({
        path: '/group/new_group_master',
        query: {
          action: 'edit',
          id: this.event?.booking_group_id
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
.fc-event::before {
  background-color: black;
}
.fc-event-info {
  display: none;
}
.fc-event {
  &:hover {
    background-color: rgba(var(--fc-event-color), 1);
    min-width: fit-content !important;
  }
  user-select: none;
  height: calc(var(--das-fc-cell-height) - 3px);
  position: absolute;
  top: 1px;
  display: grid;
  align-items: center;

  background-color: rgba(var(--fc-event-color), 0.8);
  border: 2px solid rgba(var(--fc-event-color), 1);
  color: white;
  border-radius: 8px;
  font-size: 12px;
  overflow-x: clip;
  white-space: nowrap;
}
.fc-event-label {
  > * {
    height: fit-content;
  }
  font-size: 16px;
  position: sticky;
  left: 8px;
  height: 100%;
  font-weight: 500;
  vertical-align: middle;
  letter-spacing: 0.05rem;
  width: fit-content;
}
.fc-event-icon {
  margin-left: 6px;
  margin-right: 6px;
  margin-right: 6px;
  display: flex;
  gap: 4px;
  font-size: 14px;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  i {
    height: fit-content;
  }
}
</style>
